module.exports = __webpack_public_path__ + "static/deal-id-55571f2478ac9c6fb0458a7b13544ab9.svg";